import type { ValidationFunction } from "core/validators";
import HealthCentre from "parog-web/models/health-centre";

export default function validateSupportHealthCentre(): ValidationFunction {
  return (_key, newValue: any, _oldValue, changes, content) => {
    const supportHealthCentre =
      newValue instanceof HealthCentre ? newValue : undefined;
    if (!supportHealthCentre) return true;

    const configuratorHealthCentre =
      changes?.healthCentreConfigurator instanceof HealthCentre
        ? changes.healthCentreConfigurator
        : (content?.healthCentreConfigurator as HealthCentre | undefined);

    if (
      configuratorHealthCentre &&
      supportHealthCentre.id === configuratorHealthCentre.id
    ) {
      return "Le centre support doit être différent du centre en charge du télésuivi.";
    }

    return true;
  };
}
